import Vue from 'vue'
import Router from 'vue-router'
import Escanear from '@/components/Escanear'
import Ingresar from '@/components/Ingresar'
import Bloquear from '@/components/Bloquear'
import CEC from '@/components/CEC'
import Login from '@/components/Login'

Vue.use(Router)

export default new Router({ 
  routes: [
    { path:'/',         name:'Login',component:Login },
    { path:'/escanear', name:'Escanear',component:Escanear },
    { path:'/ingresar', name:'Ingresar',component:Ingresar },
    { path:'/bloquear', name:'Bloquear',component:Bloquear },
    { path:'/cec', name:'CEC',component:CEC },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js